module.exports = __webpack_public_path__ + "img/bg.53fd60bd.jpg";